<template>
  <div>
    <h1>Worlds 2019 Groups Simulator</h1>
    <table style="width:100%" border="1">
      <tr>
        <th
          class="low-line-height"
          v-for="(groupName, index) in ['A', 'B', 'C', 'D']"
          :key="groupName"
        >
          <p>{{groupName}}</p>
          <p>{{summarizeGroup(power(groups[index]), standardDeviation(groups[index].map(t => t.power)).toFixed(1))}}</p>
        </th>
      </tr>
      <tr v-for="i of [0, 1, 2, 3]" :key="i">
        <td v-for="j of [0, 1, 2, 3]" :key="j" align="center">{{groups[j][i].name}}</td>
      </tr>
    </table>
    <p>
      Note: the strength of a team is determined by
      <a
        href="https://www.nicerodds.co.uk/league-of-legends-world-championships"
      >their odds on Bet365.</a>
    </p>
    <button id="simulate" @click="simulate">Next Draw</button>
    <button @click="copy">Share on Reddit</button>
  </div>
</template>

<script>
import _ from "underscore"

// Power is derived from the teams's odds according to Bet365.
// https://www.nicerodds.co.uk/league-of-legends-world-championships
// If a team ranks 1st on odds, then it gets 16 points.  The second team
// gets 15 points, the third 14, so on and so forth.
const teams = [
  {
    "name": "G2",
    "pool": 1,
    "league": "LEC",
    "power": 14,
  },
  {
    "name": "TL",
    "pool": 1,
    "league": "LCS",
    "power": 8,
  },
  {
    "name": "SKT",
    "pool": 1,
    "league": "LCK",
    "power": 16,
  },
  {
    "name": "FPX",
    "pool": 1,
    "league": "LPL",
    "power": 15,
  },
  {
    "name": "JT",
    "pool": 2,
    "league": "LMS",
    "power": 4,
  },
  {
    "name": "AHQ",
    "pool": 2,
    "league": "LMS",
    "power": 3,
  },
  {
    "name": "FNC",
    "pool": 2,
    "league": "LEC",
    "power": 9,
  },
  {
    "name": "C9",
    "pool": 2,
    "league": "LCS",
    "power": 7,
  },
  {
    "name": "GRF",
    "pool": 2,
    "league": "LCK",
    "power": 11,
  },
  {
    "name": "RNG",
    "pool": 2,
    "league": "LPL",
    "power": 13,
  },
  {
    "name": "IG",
    "pool": 2,
    "league": "LPL",
    "power": 12,
  },
  {
    "name": "GAM",
    "pool": 2,
    "league": "VCS",
    "power": 2,
  },
  {
    "name": "CG",
    "pool": 3,
    "league": "LCS",
    "power": 5,
  },
  {
    "name": "SPY",
    "pool": 3,
    "league": "LEC",
    "power": 6,
  },
  {
    "name": "DWG",
    "pool": 3,
    "league": "LCK",
    "power": 10,
  },
  {
    "name": "HKA",
    "pool": 3,
    "league": "LMS",
    "power": 1,
  },
]

export default {
  name: 'Simulator',
  data: () => {
    return {
      teams: teams,
      groups: null,
    }
  },
  computed: {
    poolOne() {
      return this.teams.filter(t => t.pool === 1)
    },
    poolTwo() {
      return this.teams.filter(t => t.pool === 2)
    },
    poolThree() {
      return this.teams.filter(t => t.pool === 3)
    },
  },
  created() {
    this.simulate()
  },
  methods: {
    simulate() {
      let poolOne = this.poolOne
      let poolTwo = this.poolTwo
      let poolThree = this.poolThree

      while (true) {
        poolOne = _.shuffle(poolOne)
        poolTwo = _.shuffle(poolTwo)
        let poolTwoChunks = _.chunk(poolTwo, 2)
        poolThree = _.shuffle(poolThree)

        const groups = _.chunk(_.flatten(_.zip(poolOne, poolTwoChunks, poolThree)), 4)
        if (this.noSameRegion(groups)) {
          this.groups = groups
          return
        }
      }
    },

    copy() {
      let table = 'A|B|C|D\n'
      table += ':-:|:-:|:-:|:-:\n'
      for (let i of [0, 1, 2, 3]) {
        let row = []
        for (let j of [0, 1, 2, 3]) {
          row.push(this.groups[j][i].name)
        }
        table += row.join('|') + '\n'
      }
      this.copyToClipboard(table)
      alert('The table has been copied to your clipboard.  You can paste it into your reddit comments.')
    },

    noSameRegion(groups) {
      for (let group of groups) {
        let regions = {}
        for (let team of group) {
          if (regions[team.league]) {
            return false
          }
          regions[team.league] = true
        }
      }
      return true
    },

    power(group) {
      let total = 0
      for (let team of group) {
        total += team.power
      }
      return total
    },

    standardDeviation(values) {
      var avg = this.average(values);

      var squareDiffs = values.map(function (value) {
        var diff = value - avg;
        var sqrDiff = diff * diff;
        return sqrDiff;
      });

      var avgSquareDiff = this.average(squareDiffs);

      var stdDev = Math.sqrt(avgSquareDiff);
      return stdDev;
    },

    average(data) {
      var sum = data.reduce(function (sum, value) {
        return sum + value;
      }, 0);

      var avg = sum / data.length;
      return avg;
    },

    summarizeGroup(power, std) {
      let part1
      if (power >= 38) {
        part1 = "Very strong"
      } else if (power >= 34) {
        part1 = "Strong"
      } else if (power >= 30) {
        part1 = "Weak"
      } else {
        part1 = "Very weak"
      }

      let part2
      if (std >= 5) {
        part2 = "very top heavy"
      } else if (std >= 4) {
        part2 = "top heavy"
      } else if (std >= 3) {
        part2 = "fairly even"
      } else {
        part2 = "very even"
      }

      return `${part1}, ${part2}`
    },

    copyToClipboard(str) {
      // Create new element
      var el = document.createElement('textarea');
      // Set value (string to be copied)
      el.value = str;
      // Set non-editable to avoid focus and move outside of view
      el.setAttribute('readonly', '');
      el.style = { position: 'absolute', left: '-9999px' };
      document.body.appendChild(el);
      // Select text inside element
      el.select();
      // Copy text to clipboard
      document.execCommand('copy');
      // Remove temporary element
      document.body.removeChild(el);
    },
  }
}
</script>

<style scoped>
button {
  font-size: 1em;
}

.low-line-height p:first-child {
  margin-bottom: -20px;
}

#simulate {
  margin-right: 1em;
}
</style>
